import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { paths } from "enum/paths.enum";
import {
  getLocalStorageItem,
  LocalStorageKeys,
  setLocalStorageItem,
} from "utils/react/localStorage";

/**
 * Whether the Services link shows its "New" tag. It shows until the user
 * opens the Services page once, then stays hidden in that browser (Joe).
 */
export const useServicesNewTag = (): boolean => {
  const { pathname } = useRouter();
  const onServicesPage = pathname === paths.SERVICES_INDEX;
  // Hidden until mounted: the server render has no localStorage.
  const [seen, setSeen] = useState(true);

  useEffect(() => {
    if (onServicesPage) {
      setLocalStorageItem(LocalStorageKeys.CONNEXX_SERVICES_PAGE_SEEN, "1");
      setSeen(true);
      return;
    }
    setSeen(
      getLocalStorageItem(LocalStorageKeys.CONNEXX_SERVICES_PAGE_SEEN) === "1"
    );
  }, [onServicesPage]);

  return !seen;
};
